<template>
  <section class="recap-text-box no-flicker" :class="{ active: active }">
    <div class="recap-text-box__exit-area">
      <div class="recap-text-box__exit-area__recap-text-box-button" @click="endAnimation">
        <p class="font recap-text-box__exit-area__recap-text-box-button__exit">EXIT</p>
        <img
          class="recap-text-box__exit-area__recap-text-box-button__icon"
          :src="exitIcon"
          alt="exit button"
        />
      </div>
    </div>
    <div class="recap-text-box__text-area">
      <div class="recap-text-box__text-area__wrapper">
        <div v-if="textBox.icon" class="recap-text-box__text-area__wrapper__icon">
          <img :src="textBox.icon" alt="icon" />
        </div>
        <div
          class="font--semibold recap-text-box__text-area__wrapper__text"
          :class="{ 'full-width': !textBox.icon }"
        >
          <!-- <p id="textBoxText" v-html="textBox.text"></p> -->
          <ul>
            <li v-for="(text, i) in textBox.text" :key="i">{{ text }}</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="recap-text-box__next-area">
      <div
        v-if="!lastTextBox"
        class="recap-text-box__next-area__recap-text-box-button"
        @click="onNext"
      >
        <p class="font recap-text-box__next-area__recap-text-box-button__next">NEXT</p>
        <img
          class="recap-text-box__next-area__recap-text-box-button__icon"
          :src="nextArrowIcon"
          alt="next arrow"
        />
      </div>
    </div>
  </section>
</template>

<script>
import nextArrowIcon from "@/assets/text-box-accents/next-arrow.svg";
import exitIcon from "@/assets/text-box-accents/exit-icon.svg";

import { mapState, mapMutations, mapActions } from "vuex";
export default {
  name: "recap-text-box",
  props: [
    "textBox",
    "onClose",
    "onFinish",
    "next",
    "updated",
    "continueAnimation",
    "lastTextBox",
    "previousProgress",
    "animationProgress",
    "active",
    "boxToClear",
    "boxToShow",
    "revealIconsOnTimeOut"
  ],
  data() {
    return {
      nextArrowIcon,
      exitIcon,
      i: 0,
      typeTimeOuts: [],
      progressMotion: this.previousProgress
    };
  },
  computed: {
    ...mapState({
      voiceOver: state => state.audio.voiceOver,
      currentAnimationName: state => state.analytics.currentAnimationName
    })
  },
  methods: {
    ...mapMutations([
      "updateWaitProgress",
      "updateTotalWaitTime",
      "setVoiceOver",
      "updateStopTimeIdx",
      "setTechnologyLandscapeTextBox",
      "getBenefitCardTextBox",
      "setBenefitCardTextBox",
      "updateShowAmbientAnimations"
    ]),
    ...mapActions(["getBenefitCardTextBox"]),
    endAnimation() {
      this.$ga.event({
        eventCategory: "Macro Animation",
        eventAction: "Canceled Selection",
        eventLabel: "CANCELED_BENEFIT_TEXTBOX: " + this.currentAnimationName,
        eventValue: 1
      });
      if (this.voiceOver) {
        this.voiceOver.pause();
        this.setVoiceOver(undefined);
      }
      this.setBenefitCardTextBox(undefined);
      this.updateWaitProgress(0);
      this.updateStopTimeIdx(-1);
      this.onClose(true);
    },
    revealIcons() {
      if (this.voiceOver) {
        this.voiceOver.pause();
        this.setVoiceOver(undefined);
      }
      this.setBenefitCardTextBox(undefined);
      this.updateWaitProgress(0);
      this.updateStopTimeIdx(-1);
    },
    onNext() {
      if (this.voiceOver) {
        this.voiceOver.pause();
        this.setVoiceOver(undefined);
      }
      this.clearVoiceOver();
      this.setBenefitCardTextBox(undefined);
    },
    clearDelayTimeout() {
      for (let timeout of this.typeTimeOuts) {
        clearTimeout(timeout);
      }
    },
    voiceOverEnded() {
      this.$ga.event({
        eventCategory: "Macro Animation",
        eventAction: "Completed Selection",
        eventLabel: "COMPLETED: " + this.currentAnimationName,
        eventValue: 1
      });
      if (this.voiceOver) {
        this.voiceOver.pause();
        this.setVoiceOver(undefined);
      }
      this.clearVoiceOver();
    },
    createVoiceOver(audio) {
      return new Promise((resolve, reject) => {
        if (this.voiceOver === undefined) {
          this.setVoiceOver(new Audio("/voice-overs/" + audio));
          this.voiceOver.addEventListener("ended", this.endAnimation);
        }
        resolve();
      });
    },
    clearVoiceOver() {
      if (this.voiceOver) {
        this.voiceOver.removeEventListener("ended", this.endAnimation);
      }
      this.setVoiceOver(undefined);
    }
  },
  mounted() {
    this.clearVoiceOver();
    if (this.textBox) {
      this.createVoiceOver(this.textBox.voiceOver).then(() => {
        setTimeout(() => {
          this.voiceOver.play();
        }, 2000);
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import "../styles/_vars";

.recap-text-box {
  opacity: 1;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -40%);
  width: 25vw;
  height: 15vw;
  &__exit-area {
    position: relative;
    display: flex;
    justify-content: flex-end;
    width: 100%;
    height: 13%;
    &__recap-text-box-button {
      cursor: pointer;
      height: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: flex-end;
      align-content: center;
      align-items: center;
      &__exit {
        color: $color-white;
        font-size: 1vw;
        margin-right: 0.5vw;
      }
      &__icon {
        height: 1vw;
        width: 1vw;
        margin-right: 0.5vw;
      }
    }
  }
  &__text-area {
    position: relative;
    width: 100%;
    height: 74%;
    background-color: $color-white;
    &__wrapper {
      position: relative;
      width: 100%;
      height: 100%;
      padding: 2%;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: flex-start;
      align-content: center;
      align-items: center;
      &__icon {
        width: 30%;
        height: 100%;
        margin-top: 2%;
        margin-left: 1%;
        img {
          width: 100%;
          height: 100%;
        }
      }
      &__text {
        color: $color-blue;
        padding: 0.3% 0;
        width: 75%;
        height: 100%;
        line-height: 1.3vw;
        font-size: 1vw;
        margin-left: 2%;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        align-content: center;
        align-items: center;
      }
    }
  }
  &__progress-bar {
    position: relative;
    width: 100%;
    height: 3%;
    background-color: $color-blue;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: center;
    align-items: center;
    &__animation-progress {
      width: 100%;
      height: 100%;
      &__progress {
        height: 100%;
        width: 100%;
        background-color: $color-lime;
        transform-origin: left;
        transform: scaleX(0);
      }
    }
  }
  &__next-area {
    height: 13%;
    display: flex;
    justify-content: flex-end;
    background-color: $color-black-transparent;
    &__recap-text-box-button {
      cursor: pointer;
      height: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: flex-end;
      align-content: center;
      align-items: center;
      &__next {
        color: $color-lime-bright;
        font-size: 1vw;
        margin-right: 0.5vw;
      }
      &__icon {
        height: 1vw;
        width: 1vw;
        margin-right: 0.5vw;
      }
    }
  }
  &__pointer-area {
    position: relative;
    width: 100%;
    height: 10%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
  }
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 0.5vw solid transparent;
  border-right: 0.5vw solid transparent;
  border-top: 0.4vw solid rgba(black, 0.5);
}
.arrow-left {
  justify-content: flex-start;
}
.arrow-left-margin {
  margin-left: 0.5vw;
}
.arrow-center {
  justify-content: center;
}
.arrow-right {
  justify-content: flex-end;
}

.arrow-right-margin {
  margin-right: 0.5vw;
}
.active {
  z-index: 200;
}
.full-width {
  width: 100%;
}
</style>
